<template>
  <div class="graph-settings-button">
    <div class="graph-nui-holder">
    <NUIButton
      :obj="obj"
      :displayType="'icon'"
      :appendIcon=" getSettingState ? 'show' : 'hide'"
    />
    </div>
    <div
      class="graph-setting-expanded"
      @click.stop="toggleExpansion"
    >
      <img ref="arrow" :src="require('@/assets/svg/SVG/segment_arrow.svg')" class="gs-expand-arrow"/>
    </div>
    <GraphSettingsExpansion
      ref="expansion"
      :obj="obj"
    />
  </div>
</template>

<script>
import NUIButton from '@/components/nelsonUI/NUIButton';
import GraphSettingsExpansion from '@/modal/graphSettings/GraphSettingsExpansion';
import { useSettingsStore } from '@/store/SettingsStore';

export default {
  name: 'GraphSettingsButton',
  components: {
    NUIButton,
    GraphSettingsExpansion
  },
  props: [
    'obj',
    'displayType',
  ],
  computed: {
    getSettingState () {
      return useSettingsStore().getGraphSettingsVisibilityOfType(this.$props.obj.value);
    }
  },
  methods: {
    toggleExpansion () {
      useSettingsStore().toggleGraphSettingExpansionForType(this.$props.obj.value);
      this.$refs.expansion.toggle();
    }
  }
};
</script>

<style scoped>
.graph-settings-button {
  display: flex;
  height: 55px;
}
.graph-nui-holder {
  width: 100px;
}
.graph-setting-expanded {
  background-color: white;
  width: 15px;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}
.graph-setting-expanded:hover {
  background-color: #f2f2f2;
}
.gs-expand-arrow {
  height: 12px;
  margin-left: 4px;
  margin-bottom: 16px;
}
</style>